'use client';

import Map from "@/components/map";
import Image from "next/image";

type Props = {
  sectionName: string;
};

export default function Location({ sectionName }: Props) {

  const getTextColor = (sectionName: string): string => {
    switch (sectionName) {
      case 'instalaciones':
        return 'text-orange'
      case 'eventos':
        return 'text-red'
      default:
        return 'text-gray-400';
    }
  };

  const getDecoration = (sectionName: string): {
    circlesGroup?: string;
    gradientRight: string;
    gradientLeft: string;
    gradientBottom?: string;
  } => {
    switch(sectionName) {
      case 'instalaciones':
        return {
          circlesGroup: "/images/decoration/circlesGroupOrange.svg",
          gradientRight: 'bg-gradient-to-r from-[#FBA919] to-transparent',
          gradientLeft: 'bg-gradient-to-l from-[#FBA919] to-transparent',
          gradientBottom: '/images/decoration/gradient.png',
        };
      case 'eventos':
        return {
          gradientRight: 'bg-gradient-to-r from-[#F05E73] to-transparent',
          gradientLeft: 'bg-gradient-to-l from-[#F05E73] to-transparent',
        };
      default:
        return {
          circlesGroup: "/images/decoration/circlesGroupOrange.svg",
          gradientRight: 'bg-gradient-to-r from-[#FBA919] to-transparent',
          gradientLeft: 'bg-gradient-to-l from-[#FBA919] to-transparent',
          gradientBottom: '/images/decoration/gradient.png',
        };
    }
  };

  const decoration = getDecoration(sectionName);

  return (
    <section className="relative flex flex-col justify-center items-center text-center"> 
      <div className="bigscreen-responsive mx-auto py-4 px-8">
        {decoration.circlesGroup && (
          <Image src={decoration.circlesGroup} width={150} height={500} alt="" className="hidden md:block absolute -top-0 -left-0" unoptimized/>
        )}
        <p className="font-bold text-3xl mb-4 mt-8">Ubicación <span className={`${getTextColor(sectionName)}`}>privilegiada</span></p>
        <p className="max-w-2xl text-sm font-thin text-center mb-8">Amura cuenta con una excelente ubicación en Tibás, a tan solo 5 minutos de San José, con acceso a las principales rutas de la ciudad.</p>
      </div>
      <div className="hidden md:block">
        <div className={`${decoration.gradientRight} absolute bottom-0 inset-x-1/1 w-[595px] h-[590px] opacity-20 rounded-[70px] filter blur-lg`}/>
        <div className={`${decoration.gradientLeft} absolute bottom-0 inset-x-1/2 w-[495px] h-[590px] opacity-20 rounded-[70px] filter blur-lg`}/>
        {decoration.gradientBottom && (
          <Image src={decoration.gradientBottom} width={1920} height={600} alt="" className="absolute -bottom-60 inset-x-0"/>
        )}
        <Map sectionName={sectionName} />
      </div>
    </section>
  );
}